export default "__VITE_ASSET__BxoEyhhv__"